import React, { ReactNode } from 'react';

// Today in the centre's time zone, e.g. "Thứ Ba, 13 tháng 10".
export function todayLabel(now = new Date()) {
  return new Intl.DateTimeFormat('vi-VN', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: 'Asia/Ho_Chi_Minh',
  }).format(now);
}

// "Chào buổi sáng" / "buổi chiều" / "buổi tối" by the centre's clock.
export function greeting(now = new Date()) {
  const hour = Number(
    new Intl.DateTimeFormat('en-GB', { hour: 'numeric', hourCycle: 'h23', timeZone: 'Asia/Ho_Chi_Minh' }).format(now),
  );
  if (hour < 11) return 'Chào buổi sáng';
  if (hour < 18) return 'Chào buổi chiều';
  return 'Chào buổi tối';
}

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  // Small line above the title; today's date unless the page says otherwise.
  eyebrow?: ReactNode;
}

// The shared page heading: a quiet context line, a large but light title and a
// conversational subtitle, with page actions on the right.
export function PageHeader({ title, subtitle, actions, eyebrow }: PageHeaderProps) {
  return (
    <header className="pb-1">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="min-w-0">
          <p className="text-sm text-ink-500">{eyebrow ?? todayLabel()}</p>
          <h1 className="mt-0.5 text-2xl font-medium tracking-tight text-ink-900 sm:text-[1.75rem] sm:leading-9">{title}</h1>
          {subtitle ? <p className="mt-1 max-w-3xl text-sm leading-6 text-ink-600">{subtitle}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>
    </header>
  );
}

export default PageHeader;
